import * as React from 'react';
import { Dimensions, StyleSheet, View } from 'react-native';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import CardRecuperacaoSenha, {
  CardRecuperacaoSenhaProps
} from '../../../shared/components/CardRecuperacaoSenha';
import { getTheme } from '../../../shared/modules/layout';

interface Props extends CardRecuperacaoSenhaProps, RouteComponentProps {}

class RecuperarSenhaBase extends React.Component<Props> {
  render() {
    const { history } = this.props;

    return (
      <View style={styles.container}>
        <View
          style={[
            styles.cardForm,
            { width: Math.min(345, Dimensions.get('window').width - 32) }
          ]}
        >
          <CardRecuperacaoSenha
            {...this.props}
            onNavegar={() => history.replace('/')}
          />
        </View>
      </View>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    backgroundColor: theme.backgroundColor3,
    padding: 16,
    paddingBottom: 0,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
  },
  cardForm: {
    flexDirection: 'column',
    flexBasis: 'auto',
    justifyContent: 'flex-end'
  }
});

export default withRouter(RecuperarSenhaBase);
